import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectMosDevices } from '@src/suite/common/store/global-tables/global-tables.selectors';
import { MosState } from '@src/suite/common/store/mos/models/mos.models';

const selectMosState = createFeatureSelector<MosState>('mos');

export const selectCurrentMosClientCommand = createSelector(selectMosState, state => state.clientCommand);
export const selectCurrentMosServerCommand = createSelector(selectMosState, state => state.serverCommand);
export const selectCurrentMos = createSelector(selectMosState, state => state.currentStoryMos);

export const selectMosItems = createSelector(selectMosDevices, mosDevices => (mosDevices ?? []).map(mos => ({ id: mos.ID, title: mos.Description })));
